(function (global) {
  'use strict';
  if (global.LifestyleCart) return;
  var pending = Promise.resolve();
  var root = function () { return (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/'; };
  var journalSku = function (sku) { return /^(?:B)?13390[2-7]$/.test(String(sku || '').trim().toUpperCase()); };
  var props = function (item) {
    var value = item.properties;
    if (!Array.isArray(value)) return value && typeof value === 'object' ? value : {};
    return value.reduce(function (result, property) {
      if (Array.isArray(property) && property.length >= 2) result[String(property[0])] = property[1];
      return result;
    }, {});
  };
  var count = function (value) {
    var number = Number(value);
    if (!Number.isSafeInteger(number) || number < 1 || number > 2000) throw new Error('Please choose a quantity between 1 and 2,000.');
    return number;
  };
  function cleanProperties(value) {
    var result = {};
    Object.keys(value || {}).forEach(function (key) {
      if (!/^_(?:bundle|parent$|role$|discount$|orig_cents$|now_cents$|offer_percent$|title$|lj_cart_group$)/.test(key)) result[key] = value[key];
    });
    return result;
  }
  function organizer(item) {
    var type = String(item.productType || '').toLowerCase();
    var sizes = (item.options || []).join(' ') + ' ' + (item.variantTitle || '');
    if (!/\ba5\b/i.test(sizes) && /\b(personal|pocket|mini|a4)\b/i.test(sizes)) return false;
    return /^(organizers?|organisers?|clipbooks?)$/.test(type) && /\ba5\b/i.test(sizes + ' ' + item.title + ' ' + (item.tags || []).join(' '));
  }
  function entry(item, kind) {
    var price = Number(item.price);
    if (!Number.isSafeInteger(price) || price <= 0) throw new Error('This product does not have a valid price. Please refresh the page.');
    return { variantId: Number(item.variantId || item.id), quantity: count(item.quantity || 1), price: price, title: item.title || 'Lifestyle Journal Refill', kind: kind, properties: cleanProperties(props(item)) };
  }
  function isManagedGroup(item) {
    var components = item.components || [];
    return components.length > 0 && components.some(function (component) { return journalSku(component.sku); }) &&
      components.every(function (component) { return journalSku(component.sku) || organizer(component); }) &&
      components.some(function (component) { return /^lifestyle-journal/.test(String(props(component)._bundle_type || '')); });
  }
  function plan(items, additions) {
    additions = additions || {};
    var oldLines = [], entries = [];
    var quantityTarget = null;
    if (additions.standaloneQuantity !== undefined) {
      quantityTarget = (items || []).find(function (item) { return item.key === additions.lineKey && !(item.components || []).length && journalSku(item.sku); });
      if (!quantityTarget) throw new Error('Please refresh your cart before changing this quantity.');
      if (Number(additions.standaloneQuantity) !== 0) count(additions.standaloneQuantity);
    }
    (items || []).forEach(function (item) {
      if (isManagedGroup(item)) {
        oldLines.push(item);
        item.components.slice().sort(function (left, right) {
          return Number(journalSku(right.sku) && props(right)._role === 'main') - Number(journalSku(left.sku) && props(left)._role === 'main');
        }).forEach(function (component) { entries.push(entry(component, journalSku(component.sku) ? 'refill' : 'organizer')); });
      } else if (!(item.components || []).length && journalSku(item.sku)) {
        oldLines.push(item);
        if (item !== quantityTarget || Number(additions.standaloneQuantity) !== 0) {
          var refill = entry(item, 'refill');
          if (item === quantityTarget) refill.quantity = Number(additions.standaloneQuantity);
          entries.push(refill);
        }
      }
    });
    (additions.refills || []).forEach(function (item) { entries.push(entry(item, 'refill')); });
    if (additions.organizer) entries.push(entry(additions.organizer, 'organizer'));
    if (entries.some(function (item) { return item.kind === 'refill'; })) {
      (items || []).forEach(function (item) {
        var properties = props(item);
        if (!(item.components || []).length && organizer(item) && !Object.keys(properties).some(function (key) { return /^_(?:bundle|saving|DYOF)/i.test(key); })) {
          oldLines.push(item); entries.push(entry(item, 'organizer'));
        }
      });
    }
    var compact = [];
    entries.forEach(function (item) {
      if (!Number.isSafeInteger(item.variantId) || item.variantId <= 0) throw new Error('Please select an available product.');
      var match = compact.find(function (candidate) { return candidate.variantId === item.variantId && candidate.kind === item.kind && candidate.price === item.price && JSON.stringify(candidate.properties) === JSON.stringify(item.properties); });
      if (match) match.quantity = count(match.quantity + item.quantity); else compact.push(item);
    });
    return { oldLines: oldLines, entries: compact };
  }
  function payload(entries, groupId) {
    if (!entries.length) return null;
    var organizers = entries.filter(function (item) { return item.kind === 'organizer'; });
    var refills = entries.filter(function (item) { return item.kind === 'refill'; });
    if (!organizers.length && refills.length === 1 && refills[0].quantity === 1) {
      return { id: refills[0].variantId, quantity: 1, properties: Object.assign({}, refills[0].properties, { _lj_cart_group: groupId }) };
    }
    var components = [], firstFull = !organizers.length;
    function component(item, quantity, role, now, bundleType, percent) {
      components.push({ variantId: item.variantId, quantity: quantity, role: role, orig_cents: item.price, now_cents: now, title: item.title,
        attributes: Object.assign({}, item.properties, { _lj_cart_group: groupId, _bundle_type: bundleType, _offer_percent: percent }) });
    }
    organizers.forEach(function (item, index) { component(item, item.quantity, index ? 'organizer' : 'main', item.price, index ? 'lifestyle-journal-organizer' : 'lifestyle-journal', 0); });
    refills.forEach(function (item) {
      var quantity = item.quantity;
      if (firstFull) { component(item, 1, 'main', item.price, 'lifestyle-journal', 0); quantity -= 1; firstFull = false; }
      if (quantity) component(item, quantity, 'half', Math.round(item.price * 0.85), 'lifestyle-journal-refill', 15);
    });
    if (components.length > 150) throw new Error('Please reduce the number of different products in this bundle.');
    var original = components.reduce(function (sum, item) { return sum + item.orig_cents * item.quantity; }, 0);
    var current = components.reduce(function (sum, item) { return sum + item.now_cents * item.quantity; }, 0);
    return { id: components[0].variantId, quantity: 1, properties: { _bundleIdUS: groupId, _lj_cart_group: groupId, _parent: components[0].variantId,
      _bundle_type: 'lifestyle-journal', _title: organizers.length ? 'Organizer and Lifestyle Journal Refills' : 'Lifestyle Journal Refills',
      _orig_cents: original, _now_cents: current, _discount: Number(((original - current) / original * 100).toFixed(4)), _bundleComponents: JSON.stringify(components) } };
  }
  async function request(url, body) {
    var response = await global.fetch(url, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: body ? JSON.stringify(body) : undefined });
    var result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Your cart could not be updated. Please try again.');
    return result;
  }
  async function read() {
    var response = await global.fetch(root() + 'cart?section_id=lifestyle-journal-cart-data&_lj=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Your cart could not be checked. Please refresh and try again.');
    var html = await response.text();
    var match = html.match(/<script[^>]*data-lj-cart-data[^>]*>([\s\S]*?)<\/script>/i);
    if (!match) throw new Error('Your cart could not be checked. Please refresh and try again.');
    var data = JSON.parse(match[1]);
    if (!Array.isArray(data.items)) throw new Error('Your cart could not be checked.');
    function validItem(item, component) {
      if (!item || (!component && (typeof item.key !== 'string' || !item.key)) || !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 || !Number.isSafeInteger(Number(item.quantity)) || Number(item.quantity) < 1 || !Number.isSafeInteger(Number(item.price)) || Number(item.price) < 0) return false;
      if (!component && !Array.isArray(item.components)) return false;
      return component || item.components.every(function (child) { return validItem(child, true); });
    }
    if (!data.items.every(function (item) { return validItem(item, false); })) throw new Error('Your cart could not be checked. Please refresh and try again.');
    return data;
  }
  function group(item, groupId) {
    return props(item)._lj_cart_group === groupId || (item.components || []).some(function (component) { return props(component)._lj_cart_group === groupId; });
  }
  function signature(items) {
    var totals = {};
    (items || []).forEach(function (item) {
      ((item.components || []).length ? item.components : [item]).forEach(function (component) {
        var properties = props(component), now = component.actualPrice === undefined ? (properties._now_cents === undefined ? Number(component.price) : Number(properties._now_cents)) : Number(component.actualPrice);
        var key = String(component.id || component.variantId) + ':' + now;
        totals[key] = (totals[key] || 0) + Number(component.quantity);
      });
    });
    return JSON.stringify(Object.keys(totals).sort().map(function (key) { return [key, totals[key]]; }));
  }
  function expectedSignature(newPayload, entries) {
    if (!newPayload) return signature([]);
    var components = newPayload.properties._bundleComponents;
    if (components) return signature([{ components: JSON.parse(components).map(function (component) { return { id: component.variantId, quantity: component.quantity, price: component.now_cents }; }) }]);
    return signature([{ id: newPayload.id, quantity: 1, price: entries[0].price }]);
  }
  async function removeLines(lines) {
    if (!lines.length) return;
    var updates = {};
    lines.forEach(function (line) { updates[line.key] = 0; });
    return request(root() + 'cart/update.js', { updates: updates });
  }
  function restorePayload(line) {
    if (!(line.components || []).length) return { id: line.id, quantity: line.quantity, properties: props(line) };
    var components = line.components.map(function (item) {
      var properties = props(item);
      return { variantId: item.id, quantity: count(item.quantity), role: properties._role || 'half', title: properties._title || item.title,
        orig_cents: Number(properties._orig_cents || item.price), now_cents: Number(properties._now_cents === undefined ? item.price : properties._now_cents), attributes: properties };
    });
    var id = 'lj_restore_' + Date.now() + '_' + Math.random().toString(36).slice(2);
    return { id: line.id, quantity: 1, properties: { _bundleIdUS: id, _parent: line.id, _title: line.title, _bundleComponents: JSON.stringify(components) } };
  }
  async function mutate(additions) {
    var before = await read(), proposal = plan(before.items, additions);
    var id = 'lj_cart_' + Date.now() + '_' + Math.random().toString(36).slice(2);
    var replacement = payload(proposal.entries, id), targetSignature = expectedSignature(replacement, proposal.entries);
    var oldKeys = proposal.oldLines.map(function (item) { return item.key; });
    var removalAttempted = false, rollbackBaseline = before.items;
    function unchanged(old, current) { return current && Number(old.quantity) === Number(current.quantity) && signature([old]) === signature([current]) && JSON.stringify(props(old)) === JSON.stringify(props(current)); }
    try {
      if (replacement) await request(root() + 'cart/add.js', { items: [replacement] });
      var afterAdd = await read(), added = afterAdd.items.filter(function (item) { return group(item, id); });
      if (signature(added) !== targetSignature) throw new Error('The Lifestyle offer could not be applied. Please try again.');
      rollbackBaseline = afterAdd.items.filter(function (item) { return !group(item, id); });
      if (!proposal.oldLines.every(function (old) { return unchanged(old, afterAdd.items.find(function (item) { return item.key === old.key; })); })) throw new Error('Your cart changed while the offer was being added. Please try again.');
      removalAttempted = true;
      await removeLines(proposal.oldLines);
      var after = await read();
      if (after.items.some(function (item) { return oldKeys.indexOf(item.key) !== -1; }) || signature(after.items.filter(function (item) { return group(item, id); })) !== targetSignature) throw new Error('The Lifestyle offer could not be confirmed.');
      return after;
    } catch (error) {
      try {
        var current = await read();
        var oldRemaining = proposal.oldLines.filter(function (old) { return current.items.some(function (item) { return item.key === old.key; }); });
        var currentNew = current.items.filter(function (item) { return group(item, id); });
        if (removalAttempted && !oldRemaining.length && signature(currentNew) === targetSignature) return current;
        var missing = proposal.oldLines.filter(function (old) { return !current.items.some(function (item) { return item.key === old.key; }); });
        if (removalAttempted && missing.length) await request(root() + 'cart/add.js', { items: missing.map(restorePayload) });
        await removeLines(currentNew);
        var restored = await read();
        if (signature(restored.items) !== signature(rollbackBaseline)) throw new Error('Cart recovery could not be confirmed.');
      } catch (recoveryError) {
        throw new Error('Your cart update was interrupted. Please review your cart before checking out.');
      }
      throw error;
    }
  }
  function add(additions) {
    var execute = function () {
      if (global.navigator && global.navigator.locks) return global.navigator.locks.request('filofax-lifestyle-cart', function () { return mutate(additions); });
      return mutate(additions);
    };
    var result = pending.then(execute, execute);
    pending = result.catch(function () {});
    return result;
  }
  if (global.document) {
    var cartQuantityBusy = false;
    function quantityEvent(event) {
      var target = event.target, row = target.closest && target.closest('[data-lj-standalone-variant]');
      if (!row) return;
      var input = row.querySelector('.cart-item__quantity-input');
      var adjustment = target.closest('.quantity-up, .quantity-down');
      if (!input || (event.type === 'click' && !adjustment) || (event.type !== 'click' && target !== input)) return;
      event.stopImmediatePropagation();
      if (event.type === 'keyup') return;
      if (event.type === 'keydown' && event.key !== 'Enter') return;
      event.preventDefault();
      if (cartQuantityBusy) return;
      var quantity = Number(input.value);
      if (adjustment) quantity += adjustment.classList.contains('quantity-up') ? 1 : -1;
      if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 2000) { global.alert('Please enter a whole quantity between 0 and 2,000.'); return; }
      cartQuantityBusy = true;
      input.disabled = true;
      add({ lineKey: row.dataset.ljStandaloneKey, standaloneQuantity: quantity }).then(function () {
        global.location.reload();
      }).catch(function (error) {
        global.alert(error.message);
        input.disabled = false;
        cartQuantityBusy = false;
      });
    }
    ['click', 'change', 'keyup', 'keydown'].forEach(function (type) { global.document.addEventListener(type, quantityEvent, true); });
  }
  global.LifestyleCart = { add: add, read: read, plan: plan, payload: payload, signature: signature, isJournalSku: journalSku };
})(typeof window === 'undefined' ? globalThis : window);
